/**
 * Class description
 *
 * Created: 2017-11-17
 * @author jonas
 */

import {AssetQualityLevel, IResourcesGroupConfig} from "@nolimitcity/slot-game/bin/core/resource/asset/Asset";
import {GameResources} from "@nolimitcity/slot-game/bin/core/resource/GameResources";
import {TextureAsset} from "@nolimitcity/slot-game/bin/core/resource/asset/assettypes/TextureAsset";
import {BitmapFontAsset} from "@nolimitcity/slot-game/bin/core/resource/asset/assettypes/BitmapFontAsset";
import {SpineAsset} from "@nolimitcity/slot-game/bin/core/resource/asset/assettypes/SpineAsset";

export class BonusBunniesGameAssets {

    public static MAIN_GAME_BACKGROUND:string = "mainBackground";
    public static BONUS_GAME_BACKGROUND:string = "bonusBackground";

    public static INTRO_BORDER_TILE_TOP = "resources/images/intro/Intro_Divider_Top.png";
    public static INTRO_BORDER_TILE_BOTTOM = "resources/images/intro/Intro_Divider_Bottom.png";
    public static INTRO_BLURRED_BACKGROUND = "resources/images/intro/introBackgroundBlurred.jpg";
    public static PROMO_FREESPIN = "resources/images/intro/Ticket.png";
    public static INTRO_FEATURE_ALL = "resources/images/intro/Intro_Feature_All.png";
    public static INTRO_FEATURE_1 = "resources/images/intro/Intro_Feature_1.png";
    public static INTRO_FEATURE_2 = "resources/images/intro/Intro_Feature_2.png";
    public static INTRO_FEATURE_3 = "resources/images/intro/Intro_Feature_3.png";

    public static getSymbolStateTexturePath(symbolName:string, stateName:string | null = null):string {
        if(stateName == null || stateName == "") {
            return symbolName + "/" + symbolName;
        }
        return symbolName + "/" + symbolName + "_" + stateName;
    }

    public static getSymbolStateTextures(symbolName:string, stateName:string | null = null):PIXI.Texture[] {
        return GameResources.getTextures(BonusBunniesGameAssets.getSymbolStateTexturePath(symbolName, stateName));
    }

    public static RESOURCES_GROUPS:IResourcesGroupConfig = {
        intro : [
            {
                name : "fonts",
                autoLoad : [AssetQualityLevel.HIGH],
                assets : [
                    new BitmapFontAsset("numbersOpenSans800", "fonts/bitmapfonts/NumbersOpenSans800.fnt"),
                    new BitmapFontAsset("winNumbers", "fonts/bitmapfonts/WinNumbers.fnt")
                ]
            }
        ],

        main : [
            {
                name : "introJpeg",
                assets : [
                    new TextureAsset("introJpeg0", "sheets/introJpeg/introJpeg0.json")
                ],
                animations : {
                    "introBackground" : "introBackground"
                }
            },
            {
                name : "freespin",
                autoLoad : [AssetQualityLevel.MEDIUM, AssetQualityLevel.HIGH],
                assets : [
                    new TextureAsset("freespin0", "sheets/freespin/freespin0.json")
                ],
                animations : {
                    "extraReel4Background" : "FS_extra_reel_4",
                    "extraReel4Grid" : "FS_extra_reel_4_grid",
                    "extraReel5Background" : "FS_extra_reel_5",
                    "extraReel5Grid" : "FS_extra_reel_5_grid",
                    "extraRow4Background" : "FS_extra_row_4",
                    "extraRow4Grid" : "FS_extra_row_4_grid",
                    "extraRow5Background" : "FS_extra_row_5",
                    "extraRow5Grid" : "FS_extra_row_5_grid",
                    "chestInfoPortrait" : "chest_infoA",
                    "chestInfoLandscape" : "chest_infoB"
                }
            },
            {
                name : "main",
                autoLoad : [AssetQualityLevel.MEDIUM, AssetQualityLevel.HIGH],
                assets : [
                    new TextureAsset("main0", "sheets/main/main0.json")
                ],
                animations : {
                    "button" : "ui/gameTweakerButton/button",
                    "button-disabled" : "ui/gameTweakerButton/button-disabled",
                    "betline_1" : "betline/Betline_1",
                    "betline_5" : "betline/Betline_5",
                    "betline_11" : "betline/Betline_11",
                    "betline_17" : "betline/Betline_17",
                    "betline_23" : "betline/Betline_23",
                    "betline_29" : "betline/Betline_29",
                    "Shadow" : "betline/Shadow",
                    "mainReelFrame" : "reel/mainReel",
                    "bigWinCoin0" : "BigWin/coinC/coinC_",
                    "bigWinCoin1" : "BigWin/coinB/coinB_",
                    "bigWinCoin2" : "BigWin/coinA/coinA_",
                    "bigWinCoin3" : "BigWin/star",
                    "bigWinCoin4" : "BigWin/carrot/carrot_",
                    "30Lines" : "reel/30lines",
                    "introDotActive" : "Dot_Selected",
                    "introDotInactive" : "Dot"
                }
            },
            {
                name : "mainJpeg",
                assets : [
                    new TextureAsset("mainJpeg0", "sheets/mainJpeg/mainJpeg0.json"),
                    new TextureAsset("mainJpeg1", "sheets/mainJpeg/mainJpeg1.json"),
                    new TextureAsset("mainJpeg2", "sheets/mainJpeg/mainJpeg2.json"),
                    new TextureAsset("mainJpeg3", "sheets/mainJpeg/mainJpeg3.json"),
                    new TextureAsset("mainJpeg4", "sheets/mainJpeg/mainJpeg4.json"),
                    new TextureAsset("mainJpeg5", "sheets/mainJpeg/mainJpeg5.json"),
                    new TextureAsset("mainJpeg6", "sheets/mainJpeg/mainJpeg6.json")
                ],
                animations : {
                    "mainBackground" : "introBackground",
                    "bonusBackground" : "FS_mainBackground",
                    "multiplierUpdateEffect" : "multi_refresh/multi_refresh_",
                    "B5Anticipation" : "B5_anticipation/B5_anticipation_",
                    "BaseAnticipation" : "S_anticipation/S_anticipation_"
                }
            },
            {
                name : "spine",
                assets : [
                    new SpineAsset("spineBunny", "spine/BStand.json"),
                    new SpineAsset("spineWild", "spine/W.json"),
                    new SpineAsset("wildExplosion", "spine/WEff.json"),
                    new SpineAsset("symbol", "spine/SYM.json"),
                    new SpineAsset("bonusSpinCounter", "spine/Meter.json"),
                    new SpineAsset("bigWinBackground", "spine/BigWinBG.json"),
                    new SpineAsset("FSIntro0", "spine/FSIntro_0.json"),
                    new SpineAsset("FSIntro1", "spine/FSIntro_1.json"),
                    new SpineAsset("FSIntro2", "spine/FSIntro_2.json"),
                    new SpineAsset("FSIntro3", "spine/FSIntro_3.json"),
                    new SpineAsset("SpineV", "spine/V.json"),
                    new SpineAsset("SpineB2", "spine/B2.json"),
                    new SpineAsset("SpineB3", "spine/B3.json"),
                    new SpineAsset("SpineB4", "spine/B4.json"),
                    new SpineAsset("SpineB5", "spine/B5.json"),
                    new SpineAsset("SpineCarrot", "spine/WExpand.json"),
                    new SpineAsset("ZeppelinBaseGame", "spine/zeppelinA.json"),
                    new SpineAsset("ZeppelinBonusGame", "spine/zeppelinB.json"),
                    new SpineAsset("BigWinText", "spine/BigWInText.json"),
                    new SpineAsset("BonusSpinsChest", "spine/chest.json"),
                    new SpineAsset("FSOutro", "spine/FSOutro.json"),
                    new SpineAsset("Radiolight", "spine/radiolight.json")
                ]
            },
            {
                name : "symbols",
                autoLoad : [AssetQualityLevel.MEDIUM, AssetQualityLevel.HIGH],
                assets : [
                    new TextureAsset("symbols0", "sheets/symbols/symbols0.json")
                ],
                animations : {
                    "b5NearWin" : "B5/B5_nearWinFrame",
                    "WLand" : "W/W_land/W_land_"
                }
            }
        ]
    };
}